import React, { useState, useDispatch, useEffect } from 'reactn'
import { Divider, Flex, Input, Text, Box, Button } from '@chakra-ui/react'
import "./promo.css"

const Promo = ({ globalState }) => {
  const { store } = globalState
  const { ts, showPayment, calculating } = store
  const [fetching] = useState(false)
  const setPromoCode = useDispatch("setPromoCode")
  const clearPromoCode = useDispatch("clearPromoCode")

  const [code, setCode] = useState(
    ts && ts.pc ? (ts.pc != false ? ts.pc : "") : ""
  )
  const [error, setError] = useState(
    code != "" && ts && ts.pc == false ? "INVALID PROMO CODE" : ""
  )

  useEffect(() => {
    if (calculating) {
      setError("")
    } else {
      if (code != ts.pc) {
        setCode(ts && ts.pc ? (ts.pc != false ? ts.pc : "") : "")
      }
      setError(code != "" && ts && ts.pc == false ? "INVALID PROMO CODE" : "")
    }
  }, [ts.pc, calculating])

  const onSubmit = (e) => {
    e.preventDefault()
    setPromoCode(code)
  }

  const setPCode = (code) => {
    if (code.length == 0) {
      clearCode()
    } else {
      setCode(code)
      setError("")
    }
  }

  const clearCode = () => {
    setCode("")
    setError("")
    clearPromoCode()
  }

  return (
    <Box id="promoCode" mt={1} mb={0}>
      <Divider mt={2} mb={2} />
      <Text mb="2px">
        {ts && ts.pc != false ? "PROMO CODE APPLIED" : "PROMO CODE"}
      </Text>
      <form onSubmit={onSubmit}>
        <Flex id="promoflex">
          <Box flex="1" minHeight={"50px"}>
            <Input
              variant={"promocode"}
              ml={"0px !important"}
              mr={0}
              disabled={showPayment || fetching || ts.pc != false}
              onChange={(e) => setPCode(e.target.value)}
              value={code}
              autoComplete="off"
              id="code"
              name="code"
              label="PROMO CODE"
              placeholder="PROMO CODE"
              size="md"
              minHeight={"50px"}
            />
          </Box>
          <Box margin={"auto"}>
            {ts.pc != false ? (
              <Button
                variant={"voucher"}
                type={"button"}
                disabled={fetching || showPayment}
                onClick={() => clearCode()}
              >
                CLEAR
              </Button>
            ) : (
              <Button
                variant={"voucher"}
                disabled={fetching || showPayment}
                type={"submit"}
              >
                {fetching ? "VALIDATING" : "APPLY"}
              </Button>
            )}
          </Box>
        </Flex>
        <Text minHeight={5}>{error}</Text>
      </form>
    </Box>
  )
}

export default Promo